export default "__VITE_ASSET__541dfd66__"